import { TFunction } from 'i18next'

export const EMBEDDED_EARNING_TIME_PERIODS = {
  SIX_MONTHS: '6',
  TWELVE_MONTHS: '12',
} as const

export type EmbeddedEarningTimePeriodValue =
  (typeof EMBEDDED_EARNING_TIME_PERIODS)[keyof typeof EMBEDDED_EARNING_TIME_PERIODS]

export const getEmbeddedEarningTimePeriodOptions = (t: TFunction) => [
  {
    leftText: t('rewards.embeddedCustomers.timePeriod.6Months'),
    value: EMBEDDED_EARNING_TIME_PERIODS.SIX_MONTHS,
  },
  {
    leftText: t('rewards.embeddedCustomers.timePeriod.12Months'),
    value: EMBEDDED_EARNING_TIME_PERIODS.TWELVE_MONTHS,
  },
]
